import $ from 'jquery';
import { setServizio } from './setServizio';
import ReactDOM from 'react-dom';
import React from 'react';
import { FuneralServicesSelector } from '~src/components/FuneralServices';

export const onFuneralServiceSelectedFromLoader = (servizio) => {
  setServizio(servizio, true);

  $('#modalEditorServizio').modal('hide');
  $('.modal-backdrop').remove();
};

export const renderFuneralServiceSelectorInLoader = () => {
  const domContainer = document.querySelector('#editorChooseServizio');
  ReactDOM.render(
    <FuneralServicesSelector onChange={onFuneralServiceSelectedFromLoader} />,
    domContainer
  );
};
